import emptySplitApi from "../utils/rtk";

import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

interface CategoryResponse extends CommonResponseType {
  data: any;
}

interface QueryParams {
  userId?: any;
  page?: any;
}

export const locationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postAddLocation: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.location,
        method: "POST",
        body,
      }),
    }),
    getAllLocation: builder.query<
      CommonResponseType & { data: any },
      { page?: number; search?: string; limit?: number }
    >({
      query: ({ page, search, limit }) => {
        let url = `${END_POINTS.location}?page=${page}&search=${search}&limit=${limit}`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getByIdLocation: builder.query<CategoryResponse, QueryParams>({
      query: ({ userId, page }) => {
        let url = `${END_POINTS.location}/${userId}`;

        return {
          url,
          method: "GET",
        };
      },
    }),

    editLocation: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.location}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteLocation: builder.query<
      CommonResponseType & { data: any },
      { userId: any }
    >({
      query: ({ userId }) => ({
        url: `${END_POINTS.location}/${userId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  usePostAddLocationMutation,
  useLazyGetAllLocationQuery,
  useLazyGetByIdLocationQuery,
  useEditLocationMutation,
  useLazyDeleteLocationQuery,
} = locationApi;
